import React, { useState } from 'react';
import {
  Row,
  Col,
  Table,
  Card,
  Form,
  OverlayTrigger,
  Tooltip,
  Button
} from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { useTranslation, Trans } from 'react-i18next';
import { parseDateBR, curday, formatDate } from 'helpers/date';
import { DebounceInput } from 'react-debounce-input';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ExportTable from 'components/ExportTable';
import { api } from 'services';
import DatePicker, { registerLocale } from 'react-datepicker';
import BR from 'date-fns/locale/pt-BR';

registerLocale('pt_BR', BR);

const ListingCreative = ({
  data,
  filters,
  stateFilters,
  handleFilterChange,
  actions,
  exportData
}) => {
  const { t } = useTranslation();

  const handlePageChange = page => handleFilterChange({ page });
  const [deliveryDateFrom, setDeliveryDateFrom] = useState("");
  const [deliveryDateTo, setDeliveryDateTo] = useState("");


  const isLate = end_date => {
    const date = curday('-');
    return date > end_date ? (
      <OverlayTrigger
        key="top"
        placement="top"
        overlay={<Tooltip id={`tooltip-top`}>{t('label:overdue')}</Tooltip>}
      >
        <i
          style={{ color: 'orange' }}
          className="fas fa-exclamation-triangle"
        />
      </OverlayTrigger>
    ) : (
      <OverlayTrigger
        key="top"
        placement="top"
        overlay={<Tooltip id={`tooltip-top`}>{t('label:in day')}</Tooltip>}
      >
        <i style={{ color: 'green' }} className="fas fa-check-circle" />
      </OverlayTrigger>
    );
  };

  const getIndice = () => {
    const getLabel = (id) => {
      switch (id) {
        case '9':
          return 'Aguardando envio para aprovação.';
        case '10':
          return 'Aguardando aprovação.';
        case '11':
          return 'Aguardando envio para aprovação.';
        default:
          return 'Aprovada.';
      }
    }

    let itens = [
      {background:'white',label:getLabel(stateFilters.status_id)},
      {background:'rgb(255 226 226)',label:'Aguardando edição do analista responsável.'}
    ];

    return(
      <Row className="justify-content-center mb-3">
        <Col xs="12">Índice:</Col>
        {itens.map(item=>
        <Col xs="auto" className="row">
          <Col xs="auto" style={{height:'20px',width:'40px',border:'1px solid black', borderRadius:'5px', ...item}}></Col>
          <Col xs="auto" className="pl-1"><div style={{width:'200px'}}>{item.label}</div></Col>
        </Col>
        )}
      </Row>
    );
  };

  function getExportCreative(data) {
    return (
      <Table>
        <thead>
          <tr>
            <th>{t('label:status')}</th>
            <th className="text-center align-middle">{t('label:action id')}</th>
            <th className="text-center align-middle">{t('label:action activity')}</th>
            <th className="text-center align-middle">{t('label:theme')}</th>
            <th className="text-center align-middle">{t('label:company')}</th>
            <th className="text-center align-middle">{t('label:delivery date')}</th>
            <th className="text-center align-middle">{'Dpto'}</th>
            <th className="text-center align-middle">{'Responsável'}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, i) => {
            return (
              <tr key={i}>
                <td className="text-center align-middle">
                  {item.action_comprovations.length > 0 ? 
                  getLabelStatus(item.action_comprovations[0].status_id) :  
                  t('statuses:awaiting_arts')}
                </td>
                <td className="text-center align-middle">{item.action_id}</td>
                <td className="text-center align-middle">{item.task.name}</td>
                <td className="text-center align-middle">{item.description}</td>
                <td className="text-center align-middle">{item.action.company ? item.action.company.alias : '--'}</td>
                <td className="text-center align-middle">{parseDateBR(item.delivery_date)}</td>
                <td className="text-center align-middle">
                  {item.is_internal===0?'Agência':(item.is_internal===1?'Interno':'---')}
                </td>
                <td className="text-center align-middle">{item.user?(item.user.firstname+' '+item.user.lastname):'---'}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    )
  }

  const getLabelStatus = status_id => {
    if (status_id == 10)
      return t('statuses:arts_approval');
    if (status_id == 11)
      return t('statuses:disapproved_arts');
    if (status_id == 12)
      return t('statuses:approved_arts');
    if (status_id == 18)
      return t('statuses:finished');
  }

  return (
    <>
      <Row>
        <Col>
          <Card.Body className="shadow bg-white rounded">

            {getIndice()}

            <Row className="justify-content-end">
              {filters.map((filter, k) => (
                <Col key={k} md={3}>
                  <Form.Group>
                    <Form.Label>{t(`label:${filter.name}`)}</Form.Label>
                    <Form.Control
                      value={stateFilters[filter.key]}
                      onChange={e =>
                        handleFilterChange({
                          [filter.key]: e.target.value,
                          page: 1
                        })
                      }
                      as="select"
                    >
                      <option value="">{t('label:all')}</option>
                      {filter.options.map((option, k) => (
                        <option key={k} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              ))}
            </Row>
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>{t('label:records per page')}:</Form.Label>
                  <Form.Control
                    as="select"
                    value={stateFilters.per_page}
                    onChange={e =>
                      handleFilterChange({ per_page: e.target.value, page:1 })
                    }
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={2} className="ml-auto">
                <Form.Group>
                  <Form.Label>{t('label:search')}:</Form.Label>
                  <DebounceInput
                    element={Form.Control}
                    debounceTimeout={500}
                    value={stateFilters.search}
                    onChange={e =>
                      handleFilterChange({ search: e.target.value, page:1 })
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Departamento:</Form.Label>
                  <Form.Control
                    as="select"                    
                    value={stateFilters.department}
                    onChange={e => handleFilterChange({ department: e.target.value, page:1 })}
                  >
                    <option value="">Todos</option>
                    <option value={0}>Agencia</option>
                    <option value={1}>Interno</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Data de Entrega (De):</Form.Label>
                  <DatePicker 
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    locale="pt_BR"
                    selected={deliveryDateFrom}
                    isClearable={deliveryDateFrom !== ""}
                    onChange={(date) => {
                      setDeliveryDateFrom(date)
                      handleFilterChange({ delivery_date_from: !date ? null : formatDate(date), page:1 })
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Data de Entrega (Até):</Form.Label>
                  <DatePicker 
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    locale="pt_BR"
                    disabled={!deliveryDateFrom}
                    selected={deliveryDateTo}                    
                    isClearable={deliveryDateTo !== ""}
                    maxDate={new Date()}
                    onChange={(date) => {             
                      setDeliveryDateTo(date)
                      handleFilterChange({ delivery_date_to: !date ? null : formatDate(date), page:1 })
                    }}
                  />
                </Form.Group>
              </Col>
              <Col className="mt-4">
                <ExportTable
                  buttonText={'Exportar Lista'}
                  fileName="Creative List Export"
                  data={(async () => {
                    let m_filters = { ...filters };
                    delete m_filters.page
                    delete m_filters.per_page
                    let _r = await api.get('get-actions-tasks-creation-export', { params: { ...m_filters } });
                    return {data:{data:_r.data,pagination:{}}}  ;
                  })}
                  table={(reports) => {
                    return getExportCreative(reports)
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col className="table-mobile-transform">
                <Table bordered hover responsive id="creative-table-list">
                  <thead>
                    <tr>
                      <th className="text-center align-middle">
                        {t('label:status')}
                      </th>
                      <th className="text-center align-middle">
                        {t('label:action id')}
                      </th>
                      <th className="text-center align-middle">
                        {t('label:action activity')}
                      </th>
                      <th className="text-center align-middle">
                        {t('label:theme')}
                      </th>
                      <th className="text-center align-middle">
                        {t('label:company')}
                      </th>
                      <th className="text-center align-middle">
                        {t('label:delivery date')}
                      </th>
                      <th className="text-center align-middle">
                        Data de solicitação
                      </th>
                      <th className="text-center align-middle">
                        {'Dpto'}
                      </th>
                      <th className="text-center align-middle">
                        {'Responsável'}
                      </th>
                      <th className="text-center align-middle">
                        {t('label:actions')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.data.map(item => {
                      return (
                        <tr key={item.id} style={item.is_editable?{background: 'rgb(255 226 226)'}:{}}>
                          <td className="text-center align-middle">
                          <div className="mobile-hidden-table-head">{t('label:status')}: </div>{isLate(item.delivery_date)}
                          </td>
                          <td className="text-center align-middle">
                          <div className="mobile-hidden-table-head">{t('label:action id')}: </div>{item.action_id}
                          </td>
                          <td className="text-center align-middle">
                          <div className="mobile-hidden-table-head">{t('label:action activity')}: </div>{item.task.name}
                          </td>
                          <td className="text-center align-middle">
                          <div className="mobile-hidden-table-head">{t('label:theme')}: </div>{item.description}
                          </td>
                          <td className="text-center align-middle">
                          <div className="mobile-hidden-table-head">{t('label:company')}: </div>{item.action.company.alias}
                          </td>
                          <td className="text-center align-middle">
                          <div className="mobile-hidden-table-head">{t('label:delivery date')}: </div>{parseDateBR(item.delivery_date)}
                          </td>
                          <td className="text-center align-middle">
                          <div className="mobile-hidden-table-head">Data de solicitação: </div>{item.request_date}
                          </td>
                          <td className="text-center align-middle">
                          <div className="mobile-hidden-table-head">{'Dpto'}: </div>{
                            item.is_internal===0?'Agência':(item.is_internal===1?'Interno':'---')
                            }
                          </td>
                          <td className="text-center align-middle">
                          <div className="mobile-hidden-table-head">{'Responsável'}: </div>{
                            item.user?(
                              item.user.firstname+' '+item.user.lastname
                            ):'---'
                            }
                          </td>
                          <td className="text-center align-middle">
                          <div className='mobile-transform-table-card-btn'>
                            {(() => {
                              const will_return = [];
                              actions.forEach((action, k) =>
                                will_return.push(action(item, k))
                              );
                              return will_return;
                            })()}
                          </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
            </Row>
            <Row>
              <Col>
                <Trans i18nKey="label:interpolateShowingRecords">
                  Showing {{ from: data.from || '0' }} to{' '}
                  {{ to: data.to || '0' }} from {{ total: data.total }} records
                </Trans>
              </Col>
              <Col className="d-flex justify-content-end">
                <Pagination
                  activePage={data.current_page}
                  itemsCountPerPage={data.per_page}
                  totalItemsCount={data.total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                  prevPageText="‹"
                  nextPageText="›"
                />
              </Col>
            </Row>
          </Card.Body>
        </Col>
      </Row>
    </>
  );
};

export default ListingCreative;